export default "__VITE_ASSET__89f2032f__"